import {
  Button,
  Card,
  Typography,
  Divider,
  Form,
  Select,
  Switch,
  Tooltip,
} from "antd";
import { Input } from "antd";
import { LeftOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import * as Validation from "../../../utils/helper/validation";
import toast from "react-hot-toast";
import { changeLoader } from "../../../redux/reducers/loader";
import * as Apis from "../../../utils/helper/enum";
import globalRequest from "../../../utils/global/globalRequest";
import { jwtDecode } from "jwt-decode";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../../utils/global/localData";
import { checkPermissionAction } from "../../../utils/helper/utils";
const selectDeliveryType = [
  {
    value: "fastest",
    label: "Fastest time",
  },
  {
    value: "schedule",
    label: "Scheduled time",
  },
];

const AddVehicleType = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [checked, setChecked] = useState(false);
  let { id } = useParams();

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(
      storageKeys?.USER_TOKEN,
      {},
      "get"
    );
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Vehicle Type", permissionJson, "edit")) {
        navigate("/manage-vehicle-type");
      }
    } else {
      if (!checkPermissionAction("Vehicle Type", permissionJson, "add")) {
        navigate("/manage-vehicle-type");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleSubmit = async (values) => {
    if (values.status === true) values.status = "active";
    if (values.status === false) values.status = "inactive";
    try {
      let url = Apis?.MANAGE_VEHICLE_TYPE?.CREATE_VEHICLE_TYPE;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_VEHICLE_TYPE?.EDIT_VEHICLE_TYPE + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Vehicle type created successfully";
        if (id) msg = "Vehicle type updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-vehicle-type");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };
  const getVehicleTypeDetail = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_VEHICLE_TYPE.GET_VEHICLE_TYPE_DETAIL + "/" + id,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;

        form.setFieldValue("name", data?.name);
        form.setFieldValue("loading_time", `${data?.loadingTime}`);
        form.setFieldValue("delivery_type", data?.deliveryType);
        form.setFieldValue("status", data?.status === "active" ? true : false);
        form.setFieldValue("length", `${data?.length}`);
        form.setFieldValue("width", `${data?.width}`);
        form.setFieldValue("height", `${data?.height}`);
        setChecked(data?.status === "active" ? true : false);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  useEffect(() => {
    if (id) getVehicleTypeDetail(id);
    else form.setFieldValue("status", false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Card>
        <Typography className="text-xl font-semibold" align={"left"}>
          <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
          {id ? "Edit" : "Add"} Vehicle Type
        </Typography>
        <Divider />
        <div className="min-h-[calc(100vh_-_305px)]">
          <Form
            layout="vertical"
            form={form}
            onFinish={handleSubmit}
            style={{
              maxWidth: 600,
              width: "100%",
            }}
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please enter your Name.",
                },
                {
                  max: 50,
                  message: "Please enter max 50 character.",
                },
              ]}
            >
              <Input
                size="large"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value);
                  form.setFieldValue("name", value.trimStart());
                  handleInputChange("name");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Loading Time"
              name="loading_time"
              rules={[
                {
                  required: true,
                  message: "Please enter your loading Time.",
                },
                {
                  max: 4,
                  message: "Please enter max 4 digit.",
                },
              ]}
            >
              <Input
                size="large"
                suffix="Min"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("loading_time", value.trimStart());
                  handleInputChange("loading_time");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Delivery Type"
              name="delivery_type"
              rules={[
                {
                  required: true,
                  message: "Please select delivery type.",
                },
              ]}
            >
              <Select
                mode="single"
                size="large"
                placeholder="Select Delivery Type"
                options={selectDeliveryType}
                showSearch
                filterOption={(input, selectDeliveryType) =>
                  (selectDeliveryType?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(value) => {
                  form.setFieldValue("delivery_type", value);
                  handleInputChange("delivery_type");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Status"
              name="status"
              rules={[
                {
                  required: true,
                  message: "Please enter your Status.",
                },
              ]}
            >
              <Switch
                checkedChildren="active"
                unCheckedChildren="inactive"
                checked={checked}
                onChange={(value) => {
                  setChecked(value);
                  form.setFieldValue("status", value);
                  handleInputChange("status");
                }}
              />{" "}
              <Tooltip title="This will allow the admin to assign it to a driver if enabled">
                <InfoCircleOutlined className="ml-4" />
              </Tooltip>
            </Form.Item>
            <Form.Item
              label="Length"
              name="length"
              rules={[
                {
                  required: true,
                  message: "Please enter length.",
                },
                {
                  max: 6,
                  message: "Please enter max 6 digit include decimal.",
                },
              ]}
            >
              <Input
                size="large"
                suffix="CM"
                onChange={(e) => {
                  let value = Validation.strFormat(
                    e.target.value,
                    "float|min-value:0.1"
                  );
                  form.setFieldValue("length", value.trimStart());
                  handleInputChange("length");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Width"
              name="width"
              rules={[
                {
                  required: true,
                  message: "Please enter width.",
                },
                {
                  max: 6,
                  message: "Please enter max 6 digit include decimal.",
                },
              ]}
            >
              <Input
                size="large"
                suffix="CM"
                onChange={(e) => {
                  let value = Validation.strFormat(
                    e.target.value,
                    "float|min-value:0.1"
                  );
                  form.setFieldValue("width", value.trimStart());
                  handleInputChange("width");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Height"
              name="height"
              rules={[
                {
                  required: true,
                  message: "Please enter height.",
                },
                {
                  max: 6,
                  message: "Please enter max 6 digit include decimal.",
                },
              ]}
            >
              <Input
                size="large"
                suffix="CM"
                onChange={(e) => {
                  let value = Validation.strFormat(
                    e.target.value,
                    "float|min-value:0.1"
                  );
                  form.setFieldValue("height", value.trimStart());
                  handleInputChange("height");
                }}
              />
            </Form.Item>
          </Form>
        </div>
        <Divider />
        <div className="flex justify-end gap-3">
          <Button onClick={() => navigate("/manage-vehicle-type")}>
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => form.submit()}
          >
            Save
          </Button>
        </div>
      </Card>
    </>
  );
};
export default AddVehicleType;
